export default function ArrowIcon() {
  return (
    <svg height={12} width={12} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <path fill='none' stroke='currentColor' strokeWidth='2' d='m7 2l10 10L7 22' />
    </svg>
  )
}
